import * as React from 'react';
const SortIndicator = (props) => {
    const { children, className, type, onClick } = props;
    const BEM = () => {
        const classArray = ['sort-indicator'];
        if (type) {
            classArray.push(`sort-indicator--${type}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("button", { onClick: onClick, className: BEM(), type: "button" },
        React.createElement("span", { className: "sort-indicator__text" }, children),
        React.createElement("span", { className: "sort-indicator__arrows" },
            React.createElement("span", { className: "sort-indicator__arrows-up" }),
            React.createElement("span", { className: "sort-indicator__arrows-down" }))));
};
export default SortIndicator;
